export const clinicalDistinctions = [
  "Normal developmental changes.",
  "Findings that require periodic monitoring.",
  "Problems that may benefit from timely intervention.",
  "Conditions requiring additional diagnostic investigation.",
  "Situations that warrant specialist referral.",
  "Treatment objectives that are realistic during growth.",
];

export const frameworkSteps = [
  { number: "01", title: "Assess", text: "Collect and organize the relevant clinical findings." },
  { number: "02", title: "Identify", text: "Recognize developing occlusal and dentofacial problems." },
  {
    number: "03",
    title: "Evaluate Growth",
    text: "Consider dental development, skeletal relationships, and growth-related factors.",
  },
  {
    number: "04",
    title: "Decide",
    text: "Evaluate whether observation, intervention, further investigation, or referral is appropriate.",
  },
  {
    number: "05",
    title: "Plan",
    text: "Organize the objectives and limitations of a potential Phase I treatment.",
  },
  {
    number: "06",
    title: "Monitor",
    text: "Define reassessment points and review the patient's development.",
  },
];

export const beforeItems = [
  "You recognize an orthodontic problem but aren't immediately sure whether treatment is indicated.",
  "You move between growth assessment, dentition development, appliance options, and treatment timing.",
  "You spend valuable time searching through different references to organize your reasoning.",
  "You understand individual orthodontic concepts but find it challenging to connect them into one clinical sequence.",
  "You may consider an appliance before clearly establishing the treatment objective.",
  "Every new pediatric case requires you to mentally rebuild your assessment process.",
];

export const afterItems = [
  "You begin with a systematic early orthodontic assessment.",
  "You distinguish clinical findings from treatment indications.",
  "You organize growth-related considerations before discussing intervention.",
  "You use decision pathways to compare monitoring, further assessment, intervention, and referral.",
  "You establish treatment objectives before evaluating appliance options.",
  "You document a structured Phase I planning framework that can be reviewed throughout follow-up.",
];

export const painPoints = [
  {
    title: "You identify a developing malocclusion but aren't sure whether intervention is appropriate yet.",
    text: "You recognize the clinical findings, but determining their significance during growth requires additional reasoning.",
  },
  {
    title: "You find mixed dentition assessment more complicated than expected.",
    text: "Eruption patterns, dental development, space relationships, and skeletal factors must all be considered.",
  },
  {
    title: "You understand orthodontic appliances but want a clearer way to evaluate treatment indications.",
    text: "Knowing what an appliance does is different from knowing when it is appropriate.",
  },
  {
    title: "You want to distinguish problems that require attention from findings that can be monitored.",
    text: "The challenge is not treating everything. It's recognizing which situations warrant action.",
  },
  {
    title: "You struggle to organize Phase I treatment objectives.",
    text: "You need to connect diagnosis, growth considerations, treatment goals, limitations, and reassessment.",
  },
  {
    title: "You want a more systematic way to document and review early orthodontic cases.",
    text: "Instead of relying on scattered notes, you want a repeatable assessment structure.",
  },
];

export const separateTopics = [
  "Growth and development",
  "Mixed dentition",
  "Malocclusion classification",
  "Functional assessment",
  "Orthodontic appliances",
  "Treatment timing",
  "Clinical monitoring",
];
